import { SxProps } from '@mui/material/styles'

export const getEditableFieldInputStyles = (isEditing?: boolean, hasError?: boolean): SxProps => {
  if (hasError) {
    return {}
  }

  if (isEditing) {
    return {
      '&:hover': {
        cursor: 'text',
      },
    }
  }

  return {
    // Theme v1 - input is OutlinedInput with fieldset border
    '& fieldset': { border: 'none' },
    '&:hover fieldset': { borderWidth: '1px', borderColor: 'neutralLight.300', borderStyle: 'solid' },
    // Theme v2 - input is (standard) Input with shadow as border
    '& .MuiInput-root': { boxShadow: 'none' },
  }
}
